import React from 'react';
import classnames from 'classnames';
import { SafeComponent } from '../../../shared/SafeComponent';
import { REALTIME_NOTIFICATION_LOG_MODULE } from '../../shared/constants';
import ToasterNotifications from './ToasterNotifications';
import EncourageSellerReply from './EncourageSellerReply';
import JobPostMatch from './JobPostMatch';

import classes from './index.module.scss';

interface ContainerProps {
    [key: string]: unknown;
}

const Container = (props: ContainerProps) => (
    <div className={classnames(classes.container, 'flex-col', 'flex-end', 'flex-items-end')}>
        <ToasterNotifications className={classes.item} {...props} />
        <EncourageSellerReply className={classes.item} {...props} />
        <JobPostMatch {...props} />
    </div>
);

export default SafeComponent(REALTIME_NOTIFICATION_LOG_MODULE, 'Container')(Container);
